import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { Clickable } from '@shared/Frontend/utils/clickable'
import React from 'react'
import { Actions } from '../../../../../libraries/shared/actions/actions.state'

export const BlockActions = (
  props: Actions & {
    footerClassName?: string
    datalayerCategory: string
    onClickPrimary?: () => void
    onClickSecondary?: () => void
  }
) => {
  const {
    primaryAction,
    secondaryAction,
    showActionAsLink,
    footerClassName,
    datalayerCategory,
    onClickPrimary,
    onClickSecondary,
  } = props
  const hasPrimaryAction = primaryAction && primaryAction.label && primaryAction.url
  const hasSecondaryAction = secondaryAction && secondaryAction.label && secondaryAction.url

  if (!hasPrimaryAction && !hasSecondaryAction) return <></>
  return (
    <footer className={cn('block__footer ls-clickables', footerClassName)}>
      {hasPrimaryAction && (
        <div className="ls-clickable">
          <Clickable
            elementKind="link"
            styleKind={showActionAsLink ? 'link' : 'button'}
            {...primaryAction}
            className={
              showActionAsLink ? 'block__clickable link link--filled' : 'block__clickable button'
            }
            hasBlob={true}
            icon={'icon-chevron-right'}
            onClick={() => {
              if (onClickPrimary) onClickPrimary()
              pushDatalayer({
                category: datalayerCategory,
                label: primaryAction.label,
                action: 'primary_button_click',
              })
            }}
          />
        </div>
      )}
      {hasSecondaryAction && (
        <div className="ls-clickable">
          <Clickable
            elementKind="link"
            styleKind="link"
            {...secondaryAction}
            className="block__clickable link link--hollow"
            hasBlob={true}
            icon={'icon-chevron-right'}
            onClick={() => {
              if (onClickSecondary) onClickSecondary()
              pushDatalayer({
                category: datalayerCategory,
                label: secondaryAction.label,
                action: 'secondary_button_click',
              })
            }}
          />
        </div>
      )}
    </footer>
  )
}
